<template>
  <pagination-root
    v-model:page="currentPage"
    class="flex center container"
    :items-per-page="itemsPerPage"
    show-edges
    :sibling-count="1"
    :total
  >
    <pagination-list
      v-slot="{ items }"
      class="w-full flex center gap-2 md:w-a"
    >
      <pagination-first class="h-10 vf-button w-10 vf-button-tertiary <md:hidden">
        &lt;&lt;
      </pagination-first>
      <pagination-prev class="h-10 vf-button w-10 vf-button-tertiary">
        &lt;
      </pagination-prev>
      <template v-for="(page, index) in items">
        <pagination-list-item
          v-if="page.type === 'page'"
          :key="index"
          class="h-10 vf-button w-10 vf-button-tertiary data-[selected]:vf-button-primary"
          :class="{ '<md:hidden': currentPage !== page.value }"
          :value="page.value"
        >
          {{ page.value }}
        </pagination-list-item>
        <pagination-ellipsis
          v-else
          :key="page.type"
          class="h-10 w-10 flex-inline center <md:hidden"
          :index="index"
        >
          &#8230;
        </pagination-ellipsis>
      </template>
      <pagination-next class="h-10 vf-button w-10 vf-button-tertiary">
        &gt;
      </pagination-next>
      <pagination-last class="h-10 vf-button w-10 vf-button-tertiary <md:hidden">
        &gt;&gt;
      </pagination-last>
    </pagination-list>
  </pagination-root>
</template>

<script setup lang="ts">
import { PaginationEllipsis, PaginationFirst, PaginationLast, PaginationList, PaginationListItem, PaginationNext, PaginationPrev, PaginationRoot } from 'reka-ui'

const { itemsPerPage, total } = defineProps<{ itemsPerPage: number, total: number }>()
const currentPage = defineModel<number>()
</script>
